var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCamOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cam-on_svg__clip0_145_1355)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.667 8c-.737 0-1.334.597-1.334 1.333v5.333c0 .737.597 1.334 1.334 1.334h6c.736 0 1.333-.597 1.333-1.334V9.333C14 8.597 13.403 8 12.667 8h-6zm8.666 1.333v1.372l3.613-2.58A.667.667 0 0120 8.666v6.667a.667.667 0 01-1.054.542l-3.613-2.58v1.37a2.667 2.667 0 01-2.666 2.667h-6A2.667 2.667 0 014 14.666V9.333a2.667 2.667 0 012.667-2.667h6a2.667 2.667 0 012.666 2.667zm.48 2.667l2.854 2.038V9.962L15.814 12zM12 11a1 1 0 100-2 1 1 0 000 2z",
    fill: "#231A1A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cam-on_svg__clip0_145_1355"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(4 4)",
    d: "M0 0h16v16H0z"
  })))));
}

export default SvgCamOn;